import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    details: [],
    packageInfoDetails: [],
  },
  getters: {
    details: (state) => state.details,
    packageInfoDetails: (state) => state.packageInfoDetails,
  },
  actions: {
    fetchSingle({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Inventory/api/InventoryTransactionsQuery/" + id)
          .then((r) => {
            commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    finishPrint({ commit, dispatch }, model) {
      return ajax
        .put("Inventory/api/CheckOutTransactions/print", model)
        .then(() => {
          dispatch("fetch");
        });
    },
    fetchPackagesInfo({ commit, dispatch }, { id, stockDraftOrderId }) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/PackagesInfoQuery/checkout-for-draft-order/" +
              id +
              "/" +
              stockDraftOrderId
          )
          .then((r) => {
            commit("setPackageInfoDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    },
    setPackageInfoDetails(state, data) {
      state.packageInfoDetails = data;
    },
  },
};
